"use client";

import { RatingBlock } from "@/lib/utils/lomdaV3/types";
import { WidthControl } from "./blockAppearance";

/** Topbar for the RatingBlock. Editing is inline on the block, so the topbar only
 *  carries the shared width control. */
export default function RatingSettings({ block }: { block: RatingBlock }) {
    return (
        <div className="flex items-center gap-3">
            <WidthControl blockId={block.id} />
        </div>
    );
}
